import { render, staticRenderFns } from "./ModalShipay.vue?vue&type=template&id=5a771cf8&"
import script from "./ModalShipay.vue?vue&type=script&lang=js&"
export * from "./ModalShipay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports